import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StandardDatePicker from "./StandardDatePicker";
import TablePagination from "./TablePagination";


const VisitorEnquiryLayer = () => {
  const navigate = useNavigate();
  const [visitorEnquiryList, setVisitorEnquiryList] = useState([
    {
      id: 1,
      name: "Hari Dev",
      phone: "9876543210",
      company: "Prasath Tech",
      email: "hari@example.com",
      status: "Interested",
      expoStatus: "Paid",
      paymentMethod: "UPI",
      amount: "1500",
      lastRemark: "Wants premium stall",
      nextDate: "2026-05-10"
    },
    {
      id: 2,
      name: "Alex",
      phone: "8765432109",
      company: "Global Inc",
      email: "alex@example.com",
      status: "Followup",
      expoStatus: "Free",
      paymentMethod: "-",
      amount: "0",
      lastRemark: "Asked for brochure",
      nextDate: "2026-05-05"
    },
  ]);

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [currentVisitor, setCurrentVisitor] = useState(null);
  const [statusUpdateData, setStatusUpdateData] = useState({
    newStatus: "",
    remark: "",
    date: ""
  });

  const handleOpenStatusModal = (visitor) => {
    setCurrentVisitor(visitor);
    setStatusUpdateData({
      newStatus: visitor.status,
      remark: "",
      date: visitor.nextDate || ""
    });
    setShowStatusModal(true);
  };

  const handleSaveStatusUpdate = () => {
    if (!statusUpdateData.remark) {
      toast.error("Please enter a remark");
      return;
    }

    if (statusUpdateData.newStatus === "Followup" && !statusUpdateData.date) {
      toast.error("Please select a next followup date");
      return;
    }

    if (statusUpdateData.newStatus === "Booked") {
      const booked = JSON.parse(localStorage.getItem("visitor_booked_list") || "[]");
      localStorage.setItem("visitor_booked_list", JSON.stringify([...booked, {
        ...currentVisitor,
        status: "Booked",
        lastRemark: statusUpdateData.remark
      }]));
      setVisitorEnquiryList((prev) => prev.filter((v) => v.id !== currentVisitor.id));
      toast.success("Visitor moved to Booked list");
    } else if (statusUpdateData.newStatus === "Rejected") {
      setVisitorEnquiryList((prev) => prev.filter((v) => v.id !== currentVisitor.id));
      toast.error("Visitor lead Rejected");
    } else {
      setVisitorEnquiryList(prev => prev.map(v =>
        v.id === currentVisitor.id
          ? {
            ...v,
            status: statusUpdateData.newStatus,
            nextDate: statusUpdateData.date,
            lastRemark: statusUpdateData.remark
          }
          : v
      ));
      toast.success("Status Updated Successfully");
    }

    setShowStatusModal(false);
  };

  return (
    <>
      <div className="card h-100 p-0 radius-12 border-0 shadow-sm">
        <div
          className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between"
          style={{
            background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)",
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <Link
              to="/upcoming-expo"
              className="btn btn-sm btn-light d-flex align-items-center justify-content-center w-36-px h-36-px rounded-circle p-0"
            >
              <Icon icon="solar:arrow-left-linear" className="text-xl text-dark" />
            </Link>
            <h6 className="text-white mb-0 fw-bold">Visitor Enquiry List</h6>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead style={{ backgroundColor: "#f7e7da" }}>
                <tr>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>S.No</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Name</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Phone</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Company</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Expo Status</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Payment</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Amount</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Status</th>
                  <th scope="col" style={{ color: "black", fontWeight: "bold", textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {visitorEnquiryList.length > 0 ? (
                  visitorEnquiryList.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.phone}</td>
                      <td>{item.company}</td>
                      <td>
                        <span className={`badge px-12 py-4 radius-pill ${item.expoStatus === 'Paid' ? 'bg-success-focus text-success-main' : 'bg-neutral-100 text-neutral-600'}`}>
                          {item.expoStatus}
                        </span>
                      </td>
                      <td className="fw-medium">{item.paymentMethod || "-"}</td>
                      <td className="fw-bold">₹{item.amount || 0}</td>
                      <td>
                        <span
                          className={`badge px-12 py-4 radius-4 cursor-pointer transition-all hover-scale-sm ${item.status === 'Followup' ? 'bg-info-focus text-info-main' :
                              item.status === 'Interested' ? 'bg-primary-focus text-primary-main' :
                                'bg-neutral-100 text-neutral-600'
                            }`}
                          onClick={() => handleOpenStatusModal(item)}
                          title="Click to manage status"
                          style={{ cursor: 'pointer' }}
                        >
                          {item.status}
                        </span>
                        {item.nextDate && <div className="text-xs text-secondary-light mt-1">Next: {item.nextDate}</div>}
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-outline-primary btn-sm radius-8 d-inline-flex align-items-center gap-2"
                          onClick={() => handleOpenStatusModal(item)}
                        >
                          <Icon icon="solar:settings-bold" /> Manage
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-24">No enquiries found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Status Management Modal */}
      {showStatusModal && currentVisitor && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 border-0 shadow-lg">
              <div className="modal-header border-bottom py-16 px-24" style={{ background: 'linear-gradient(135deg, #000000, #bb0007, #ed1c24)' }}>
                <h6 className="modal-title text-white mb-0 d-flex align-items-center gap-2">
                  <Icon icon="solar:user-speak-bold" /> Manage Status: {currentVisitor.name}
                </h6>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowStatusModal(false)}></button>
              </div>
              <div className="modal-body p-24">
                {/* Last Remark Section */}
                <div className="mb-20 p-12 bg-neutral-50 radius-8 border">
                  <label className="text-xs fw-bold text-secondary-light uppercase mb-4 d-block">Last Remark</label>
                  <p className="text-sm italic mb-0 text-dark">"{currentVisitor.lastRemark || "No previous remarks available."}"</p>
                </div>

                <div className="row gy-4">
                  <div className="col-12">
                    <label className="form-label fw-bold">Update Status <span className="text-danger">*</span></label>
                    <select
                      className="form-select radius-8"
                      value={statusUpdateData.newStatus}
                      onChange={(e) => setStatusUpdateData({ ...statusUpdateData, newStatus: e.target.value })}
                    >
                      <option value="Interested">Enquiry / Interested</option>
                      <option value="Followup">Follow-up</option>
                      <option value="Booked">Convert to Booked</option>
                      <option value="Rejected">Reject Lead</option>
                    </select>
                  </div>

                  {statusUpdateData.newStatus === "Followup" && (
                    <div className="col-12 animate-fade-in">
                      <label className="form-label fw-bold">Next Followup Date <span className="text-danger">*</span></label>
                      <StandardDatePicker
                        value={statusUpdateData.date}
                        minDate="today"
                        onChange={(e) => setStatusUpdateData({ ...statusUpdateData, date: e.target.value })}
                        className="form-control radius-8"
                      />
                    </div>
                  )}

                  <div className="col-12">
                    <label className="form-label fw-bold">New Remark / Update <span className="text-danger">*</span></label>
                    <textarea
                      className="form-control radius-8"
                      rows="3"
                      placeholder="What did the visitor say? Enter current update..."
                      value={statusUpdateData.remark}
                      onChange={(e) => setStatusUpdateData({ ...statusUpdateData, remark: e.target.value })}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-top p-16 bg-light radius-bottom-16">
                <button type="button" className="btn btn-secondary radius-8 px-24" onClick={() => setShowStatusModal(false)}>Cancel</button>
                <button
                  type="button"
                  className={`btn radius-8 px-32 fw-bold text-white ${statusUpdateData.newStatus === 'Rejected' ? 'btn-danger' :
                      statusUpdateData.newStatus === 'Booked' ? 'btn-success' :
                        'btn-primary'
                    }`}
                  style={{ backgroundColor: statusUpdateData.newStatus === 'Rejected' ? '' : statusUpdateData.newStatus === 'Booked' ? '' : '#ed1c24', border: 'none' }}
                  onClick={handleSaveStatusUpdate}
                >
                  Save Changes
                </button>
              </div>
              {/* <TablePagination
                currentPage={currentPage}
                totalPages={Math.ceil(totalItems / itemsPerPage)}
                onPageChange={handlePageChange}
                rowsPerPage={itemsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
                totalRecords={totalItems}
              /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VisitorEnquiryLayer;
